import React, { useContext, useMemo } from 'react';

import Button from 'ati-ui-react/components/Button/v3';
import Link from 'ati-ui-react/components/Link';

import LaptopIcon from './LaptopIcon';
import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';
import { ConfigContext } from 'contexts';

const ApiBanner = () => {
    const strings = useLocalized(i18nStrings);
    const { billingUrl } = useContext(ConfigContext);
    const payAccessLink = useMemo(() => `${billingUrl}/addinvoice?option=${window?.atiUser?.is_paid_user ? 2 : 1}&services=566&currencyId=1`, [billingUrl]);

    return (
        <div className={styles['informer']}>
            <div className={styles['info']}>
                <div className={styles['title']}>
                    {strings.title}
                </div>
                <div className={styles['text']}>
                    {strings.text}
                    <Link
                        small
                        href="//ati.su/landings/api-ati"
                        target="_blank"
                        type="external"
                    >
                        {strings.details}
                    </Link>
                </div>
                <div className={styles['text']}>
                    {strings.accessLicense}
                </div>
                <Button
                    filled
                    size="small"
                    theme="default"
                    onClick={(e) => {
                        e.preventDefault();
                        window.open(payAccessLink);
                    }}
                >
                    {strings.getAccess}
                </Button>
            </div>
            <LaptopIcon/>
        </div>
    );
};

export default ApiBanner;
